import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import { routesWhiteList } from './setting.config'
import { TabsBarStorage } from '@/utils/storage'
import { ShopTokenStorage } from '@/utils/storage'
import i18n from '@/locale'
import { sendWebFunnyEvent } from '@/utils'
import { WebFunnyEventCode } from '@/constants'
import {
  hasMenuPath,
  resolveAppHomePath,
  resolveCashierEntryPath,
} from '@/utils/resolveAppHomePath'

NProgress.configure({
  easing: 'ease',
  speed: 500,
  trickleSpeed: 200,
  showSpinner: false,
})
let startTime = new Date().getTime()
function calcPageStayTime(to, from) {
  if (to.name && from.name) {
    const currentTime = new Date().getTime()
    sendWebFunnyEvent(WebFunnyEventCode.PAGE, {
      stayTime: (currentTime - startTime) / 1000,
      caiDan: from.meta.title,
    })
  }
  if (to?.matched[0]) {
    sendWebFunnyEvent(WebFunnyEventCode.PAGE, {
      stayTime: 0,
      caiDan: to.matched[0].meta.title,
    })
  }
}

router.beforeEach(async (to, from, next) => {
  calcPageStayTime(to, from)
  NProgress.start()
  const accessToken = store.getters['user/accessToken']
  const shopToken = store.getters['user/shopToken'] || ShopTokenStorage.get()
  if (accessToken && shopToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }
    // 是否已经生成权限路由
    const routes = store.getters['routes/routes']
    if (routes?.length || to.path === '/401') {
      // 权限已加载后访问 / 或无权 /cashier，仍需纠正（避免 constantRoutes 硬 redirect）
      if (to.path === '/') {
        const homePath = resolveAppHomePath(store)
        if (homePath && homePath !== to.path) {
          next({ path: homePath, replace: true })
          return
        }
      }
      if (to.path === '/cashier' && !hasMenuPath(store, '/cashier')) {
        const entryPath = resolveCashierEntryPath(store)
        if (entryPath && entryPath !== to.path) {
          next({ path: entryPath, replace: true })
          return
        }
      }
      next()
      return
    }

    // 获取路由权限数据
    try {
      await store.dispatch('user/getUserInfo')
    } catch (err) {
      console.error(err)
    }

    const permissions = store.getters['user/permissions']
    if (permissions?.length) {
      const accessRoutes = await store.dispatch('routes/setRoutes', permissions[0].children)
      accessRoutes?.forEach((route) => router.addRoute(route))
      // 初始化TabsBar
      const routes = TabsBarStorage.get()?.map((path) => router.match(path))
      if (routes) store.dispatch('tabsBar/initTab', routes)
      if (to.path !== '/index') {
        store.dispatch('tabsBar/setTab', router.match('/index'))
      }
      const homePath = resolveAppHomePath(store)
      if (homePath && (to.path === '/' || to.path === '/cashier' || to.path === '/newCashier')) {
        const resolved = router.resolve(homePath)
        if (!resolved.route.matched.length || to.path !== homePath) {
          next({ path: homePath, replace: true })
          return
        }
      }
      if (to.path === '/cashier' && !hasMenuPath(store, '/cashier')) {
        const entryPath = resolveCashierEntryPath(store)
        if (entryPath && entryPath !== to.path) {
          next({ path: entryPath, replace: true })
          return
        }
      }
      next({ ...to, replace: true })
      return
    }

    // 用户无权限
    next({ path: '/401' })
    return
  }

  // 判断当前路由是否在白名单中
  if (routesWhiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    // 无 accessToken , 进入登录页
    next({ path: '/login', query: { redirect: to.path } })
  }
})

router.beforeResolve((to, from, next) => {
  next()
  document.title = i18n.t('新零售') + '●' + to?.meta?.title || process.env.VUE_APP_NAME
  NProgress.done()
})

router.afterEach((to) => {
  handleKeepAlive(to)
})

function handleKeepAlive(to) {
  if (to.matched && to.matched.length > 2) {
    for (let i = 0; i < to.matched.length; i++) {
      const element = to.matched[i]
      if (element.components.default.name === 'EmptyLayout') {
        to.matched.splice(i, 1)
        handleKeepAlive(to)
      }
    }
  }
}
